import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

const ProductStock = () => {
  const [form, setForm] = useState({
    category_id: "",
    subcategory_id: "",
    product_id: "",
    product_variant_id: "",
    purchase_qty: "",
    purchase_date: "",
  });

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [variants, setVariants] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [editId, setEditId] = useState(null);

  const schoolId = localStorage.getItem("school_id");
  const added_by = localStorage.getItem("id");

  const categoryURL = `https://dgps.co.in/api/product/category/list?school_id=${schoolId}`;
  const subcategoryURL = `https://dgps.co.in/api/product/subcategory/list`;
  const productURL = `https://dgps.co.in/api/product/list`;
  const variantURL = `https://dgps.co.in/api/product/variant/list`;
  const baseURL = "https://dgps.co.in/api/stock";
  const addURL = `${baseURL}/add`;
  const updateURL = `${baseURL}/update`;
  const deleteURL = `${baseURL}/delete`;
  const listURL = `${baseURL}/list?school_id=${schoolId}`;

  // ✅ Fetch categories
  const fetchCategories = async () => {
    try {
      const res = await fetch(categoryURL);
      const data = await res.json();
      setCategories(data || []);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  // ✅ Fetch subcategories
  const fetchSubcategories = async (categoryId) => {
    if (!categoryId) return setSubcategories([]);
    try {
      const res = await fetch(`${subcategoryURL}?category_id=${categoryId}`);
      const data = await res.json();
      setSubcategories(data || []);
    } catch (err) {
      console.error("Error fetching subcategories:", err);
    }
  };

  // ✅ Fetch products
  const fetchProducts = async (subcategoryId) => {
    if (!subcategoryId) return setProducts([]);
    try {
      const res = await fetch(`${productURL}?school_id=${schoolId}&subcategory_id=${subcategoryId}`);
      const data = await res.json();
      setProducts(data || []);
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  };

  // ✅ Fetch variants
  const fetchVariants = async (productId) => {
    if (!productId) return setVariants([]);
    try {
      const res = await fetch(`${variantURL}?school_id=${schoolId}&product_id=${productId}`);
      const data = await res.json();
      setVariants(data || []);
    } catch (err) {
      console.error("Error fetching variants:", err);
    }
  };

  // ✅ Fetch stocks
  const fetchStocks = async () => {
    try {
      const res = await fetch(listURL);
      const data = await res.json();
      setStocks(data || []);
      console.log("Stock Data",data);
    } catch (err) {
      console.error("Error fetching stocks:", err);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchStocks();
  }, []);

  // ✅ Form change
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCategoryChange = (e) => {
    const categoryId = e.target.value;
    setForm({ ...form, category_id: categoryId, subcategory_id: "", product_id: "", product_variant_id: "" });
    fetchSubcategories(categoryId);
    setSubcategories([]); setProducts([]); setVariants([]);
  };

  const handleSubcategoryChange = (e) => {
    const subId = e.target.value;
    setForm({ ...form, subcategory_id: subId, product_id: "", product_variant_id: "" });
    fetchProducts(subId);
    setProducts([]); setVariants([]);
  };

  const handleProductChange = (e) => {
    const prodId = e.target.value;
    setForm({ ...form, product_id: prodId, product_variant_id: "" });
    fetchVariants(prodId);
    setVariants([]);
  };

  const handleVariantChange = (e) => {
    setForm({ ...form, product_variant_id: e.target.value });
  };

  // ✅ Save stock
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form, school_id: schoolId,added_by:added_by };

    try {
      if (editId) {
        payload.id = editId;
        await fetch(updateURL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else {
        await fetch(addURL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      }

      setForm({
        category_id: "",
        subcategory_id: "",
        product_id: "",
        product_variant_id: "",
        purchase_qty: "",
        purchase_date: "",
      });
      setEditId(null);
      fetchStocks();
    } catch (err) {
      console.error("Error saving stock:", err);
    }
  };

  // ✅ Edit
  const handleEdit = (item) => {
    setForm({
      product_variant_id: item.product_variant_id,
      purchase_qty: item.purchase_qty,
      purchase_date: item.purchase_date,
    });
    setEditId(item.id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Delete
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this stock?")) return;
    try {
      await fetch(deleteURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      fetchStocks();
    } catch (err) {
      console.error("Delete error", err);
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <div style={{ flex: 1, backgroundColor: "#f4f6f8" }}>
        <main style={{ padding: "30px", maxWidth: "1000px", margin: "auto", marginTop: "0px" }}>
          {/* Add/Edit Stock Section */}
          <section style={cardStyle}>
            <h2 style={titleStyle}>{editId ? "✏️ Edit Stock" : "➕ Add New Stock"}</h2>
            <form onSubmit={handleSubmit}>
              <div style={formGrid}>
                {/* Category */}
                <FormGroup label="Category">
                  <select
                    name="category_id"
                    value={form.category_id || ""}
                    onChange={handleCategoryChange}
                    style={fullWidthInput}
                    required
                  >
                    <option value="">-- Select Category --</option>
                    {categories.map((cat) => (
                      <option key={cat.id} value={cat.id}>{cat.category_name}</option>
                    ))}
                  </select>
                </FormGroup>

                {/* Subcategory */}
                <FormGroup label="Subcategory">
                  <select
                    name="subcategory_id"
                    value={form.subcategory_id || ""}
                    onChange={handleSubcategoryChange}
                    style={fullWidthInput}
                    required
                  >
                    <option value="">-- Select Subcategory --</option>
                    {subcategories.map((sub) => (
                      <option key={sub.id} value={sub.id}>{sub.subcategory_name}</option>
                    ))}
                  </select>
                </FormGroup>

                {/* Product */}
                <FormGroup label="Product">
                  <select
                    name="product_id"
                    value={form.product_id || ""}
                    onChange={handleProductChange}
                    style={fullWidthInput}
                    required
                  >
                    <option value="">-- Select Product --</option>
                    {products.map((p) => (
                      <option key={p.id} value={p.id}>{p.product_name}</option>
                    ))}
                  </select>
                </FormGroup>

                {/* Variant */}
                <FormGroup label="Variant">
                  <select
                    name="product_variant_id"
                    value={form.product_variant_id || ""}
                    onChange={handleVariantChange}
                    style={fullWidthInput}
                    required
                  >
                    <option value="">-- Select Variant --</option>
                    {variants.map((v) => (
                      <option key={v.id} value={v.id}>{v.variant_name}</option>
                    ))}
                  </select>
                </FormGroup>

                {/* Quantity */}
                <FormGroup label="Purchase Quantity">
                  <input
                    type="number"
                    name="purchase_qty"
                    value={form.purchase_qty}
                    onChange={handleChange}
                    style={fullWidthInput}
                    required
                  />
                </FormGroup>

                {/* Date */}
                <FormGroup label="Purchase Date">
                  <input
                    type="date"
                    name="purchase_date"
                    value={form.purchase_date}
                    onChange={handleChange}
                    style={fullWidthInput}
                    required
                  />
                </FormGroup>
              </div>

              <div style={{ textAlign: "right", marginTop: "20px" }}>
                <button type="submit" style={buttonStyle}>
                  {editId ? "Update Stock" : "Add Stock"}
                </button>
              </div>
            </form>
          </section>

          {/* Stock List */}
          <section style={cardStyle}>
            <h2 style={titleStyle}>📋 Stock List</h2>
            {stocks.length === 0 ? (
              <p>No stock records found.</p>
            ) : (
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {stocks.map((item, idx) => (
                  <li
                    key={item.id}
                    style={{
                      marginBottom: "15px",
                      padding: "15px",
                      borderRadius: "8px",
                      background: idx % 2 === 0 ? "#f9f9f9" : "#eef3f9",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <strong style={{ fontSize: "16px", color: "#333" }}>
                        {item.variant_name}
                      </strong>
                      <div style={{ color: "#777", fontSize: "13px" }}>
                        Qty: {item.stock_qty} | Date: {item.purchase_date}
                      </div>
                    </div>
                    <div>
                      <FaEdit
                        onClick={() => handleEdit(item)}
                        style={{ color: "#0077cc", cursor: "pointer", marginRight: "15px" }}
                      />
                      <FaTrash
                        onClick={() => handleDelete(item.id)}
                        style={{ color: "red", cursor: "pointer" }}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </section>
        </main>
      </div>
    </div>
  );
};

// Reusable FormGroup
const formGrid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "20px",
};

const fullWidthInput = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "15px",
  boxSizing: "border-box",
};

const FormGroup = ({ label, children, style }) => (
  <div style={{ ...style }}>
    <label style={{ marginBottom: "6px", display: "block", fontWeight: 500, color: "#444" }}>
      {label}
    </label>
    {children}
  </div>
);

const buttonStyle = {
  padding: "10px 25px",
  backgroundColor: "#0077cc",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontSize: "15px",
  cursor: "pointer",
};

const cardStyle = {
  background: "#ffffff",
  padding: "25px",
  borderRadius: "12px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
  marginBottom: "30px",
};

const titleStyle = {
  color: "#0077cc",
  marginBottom: "25px",
};

export default ProductStock;
